'use client'

import icon_warning from "@/public/image/etc/icon_warning.png"
import { useTranslations } from "next-intl"

export default function NotFound(){
    const a = useTranslations("Sentence")
    return (
        <div className={`pageNotFound`}>
            <div>
                <img src={icon_warning.src} />
                {a("InvalidPage")}
            </div>
        </div>
    )
}